module.exports = __webpack_public_path__ + "img/loading.414d75fc.svg";